// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'countryside-builders-frontend';

export const PAGE_PATH = '/country-builders';
